import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSelectedModule } from '../../store/actions/auth';
import { Button } from 'primereact/button';
import './ModuleSelectionPage.scss';

const MODULES = [
  { label: 'HR',          emoji: '👥', path: '/dashboard/hr' },
  { label: 'Payroll',     emoji: '💰', path: '/dashboard/payroll' },
  { label: 'Attendance',  emoji: '📅', path: '/dashboard/attendance' },
  { label: 'Recruitment', emoji: '🧑‍💼', path: '/dashboard/recruitment' },
  { label: 'Performance', emoji: '📊', path: '/dashboard/performance' },
  { label: 'Training',    emoji: '🎓', path: '/dashboard/training' },
];

const RADIUS = 145;
const CENTER = 190;

function getPosition(index, total) {
  const angle = (index * 360 / total - 90) * (Math.PI / 180);
  return {
    x: CENTER + RADIUS * Math.cos(angle),
    y: CENTER + RADIUS * Math.sin(angle),
  };
}

function getSpokeStyle(index, total) {
  const { x, y } = getPosition(index, total);
  const dx = x - CENTER;
  const dy = y - CENTER;
  const length = Math.sqrt(dx * dx + dy * dy) - 50;
  const angle = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
  return {
    left: `${CENTER}px`,
    top: `${CENTER}px`,
    height: `${length}px`,
    transform: `rotate(${angle}deg) translateX(-50%)`,
  };
}

class ModuleSelectionPage extends Component {
  state = { selected: null };

  handleSelect = (mod) => {
    this.setState({ selected: mod });
  }

  handleProceed = () => {
    const { selected } = this.state;
    if (!selected) return;
    this.props.setSelectedModule(selected.label);
    this.props.history.push(selected.path);
  }

  render() {
    const { selected } = this.state;
    const total = MODULES.length;

    return (
      <div className="module-selection-page">
        <h2 className="page-title">Select a module to continue</h2>

        <div className="hub-wrapper">

          {/* Spokes */}
          {MODULES.map((mod, i) => (
            <div
              key={`spoke-${mod.label}`}
              className="spoke"
              style={getSpokeStyle(i, total)}
            />
          ))}

          {/* Center logo */}
          <div className="center-logo">
            <img src="/assets/images/logo.png" alt="Company Logo" />
            <span>ACME Corp</span>
          </div>

          {/* Module cards */}
          {MODULES.map((mod, i) => {
            const { x, y } = getPosition(i, total);
            return (
              <div
                key={mod.label}
                className={`module-card ${selected?.label === mod.label ? 'selected' : ''}`}
                style={{
                  left: `${x}px`,
                  top: `${y}px`,
                  transform: 'translate(-50%, -50%)',
                }}
                onClick={() => this.handleSelect(mod)}
              >
                <span className="module-emoji">{mod.emoji}</span>
                <span className="module-label">{mod.label}</span>
              </div>
            );
          })}
        </div>

        {selected && (
          <Button
            label={`Go to ${selected.label}`}
            icon="pi pi-arrow-right"
            iconPos="right"
            className="proceed-btn"
            onClick={this.handleProceed}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setSelectedModule: (module) => dispatch(setSelectedModule(module))
});

export default connect(null, mapDispatchToProps)(ModuleSelectionPage);
